export const dateFormatList = ['DD.MM.YYYY', 'DD.MM.YY'];